// src/components/layout/Header.jsx
// STATUS: stable | UPDATED: 2026-08-02
// LOG:
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
//   2026-07-23  Avatar menu owns Settings + Sign out on desktop
// Top header bar. Avatar menu (top right): Account settings + Sign out.
// Uses display_name and initials from the profile. Black avatar.

import { useNavigate } from 'react-router-dom'
import { Box, HStack, Menu, MenuButton, MenuList, MenuItem, MenuDivider, Avatar, Button } from '@chakra-ui/react'
import Presence, { LiveDot } from './Presence'
import { LogOut, Settings as SettingsIcon } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'
import { displayNameFor, initialsFor } from '../../lib/names.js'
import { signOut } from '../../lib/auth'

export default function Header() {
  const navigate = useNavigate()
  const { user, profile } = useAuth()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login/', { replace: true })
  }

  const displayName = displayNameFor(profile, user)
  const initials = initialsFor(profile, user)

  return (
    <Box
      as="header"
      h="64px"
      px={6}
      borderBottom="1px solid"
      borderColor="line"
      bg="card"
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      position="sticky"
      top={0}
      zIndex={10}
    >
      <HStack spacing={0}>
        {/* Whoever else from this dealership is here right now. Super admins see
            the other super admin, which is how Jazz and Tyler see each other. */}
        <Presence profile={profile} />

        <Menu>
          <MenuButton as={Button} variant="ghost" px={2} py={1} h="auto" borderRadius="pill" _hover={{ bg: 'surface' }}>
          {/* THE AVATAR IS THE WHOLE CONTROL, ON EVERY SIZE.
              Tyler, 2026-09-10: "Up on the top right, it should just be the
              avatar only."
              What was here told him his own name and, before that, that he was
              a Super Admin. Both are things a person knows about themselves,
              and the header is the one strip of chrome on a phone that competes
              with the thing he came to use. Settings live under More and in this
              menu, so nothing is lost by saying nothing. */}
            <Box position="relative" display="inline-flex">
              <Avatar size="sm" name={displayName} getInitials={() => initials} bg="ink" color="onInk" />
              {/* You are looking at this page, so you are here. */}
              <LiveDot />
            </Box>
          </MenuButton>
        {/* Item height comes from the Menu entry in the theme, which sets a
            44px minimum for every menu in the app. */}
          <MenuList>
            <MenuItem icon={<SettingsIcon size={16} />} onClick={() => navigate('/settings/')}>
              Account settings
            </MenuItem>
            <MenuDivider />
            <MenuItem icon={<LogOut size={16} />} onClick={handleSignOut}>
              Sign out
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    </Box>
  )
}